(function () {
  async function loadRecommendations(host, productId, sectionId) {
    if (!host?.dataset.baseUrl || !productId || host.dataset.loaded === 'true') return;

    const url = `${host.dataset.baseUrl}?section_id=cod-product-recommendations&product_id=${encodeURIComponent(productId)}&limit=4&intent=related`;

    try {
      const res = await fetch(url);
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const block = doc.querySelector('.product-cod-success__similar--api');
      if (block?.innerHTML.trim()) {
        host.innerHTML = block.outerHTML;
        host.dataset.loaded = 'true';
      }
    } catch (e) {
      console.warn('[cod-confirmation] recommendations', e);
    }
  }

  function formatOrderRef(ref) {
    const value = String(ref || '').trim();
    if (!value) return '';
    return value.startsWith('#') ? value : `#${value}`;
  }

  document.addEventListener('DOMContentLoaded', () => {
    const root = document.querySelector('[data-cod-confirmation]');
    if (!root) return;

    document.body.classList.add('product-cod-order-confirmed');

    const params = new URLSearchParams(window.location.search);
    const ref = params.get('ref');
    const refEl = root.querySelector('[data-order-name]');

    if (ref && refEl) {
      refEl.textContent = formatOrderRef(ref);
      refEl.classList.add('cod-conf__order-num--ready');
    } else if (refEl) {
      refEl.textContent = 'En cours';
      refEl.classList.remove('cod-conf__order-num--ready');
    }

    const productId = params.get('product_id');
    const host = root.querySelector('[data-cod-recommendations]');
    if (host && productId) {
      loadRecommendations(host, productId, root.dataset.sectionId);
    }
  });
})();
